import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "chat",

  initialState: {
    list: [],
    selected: null,
    messages: [],
  },

  reducers: {
    setSelectedChat: (state, { payload: selected }) => ({
      ...state,
      selected,
    }),
    setChatList: (state, { payload: list }) => ({
      ...state,
      list,
    }),
    setMessages: (state, { payload: messages }) => ({
      ...state,
      messages,
    }),
  },
});

export const { setSelectedChat, setChatList, setMessages } = slice.actions;

export default slice.reducer;

export const getSelectedChat = (store) => store.chat.selected;
export const getChatList = (store) => store.chat.list;
export const getMessages = (store) => store.chat.messages;
